import React, { memo, useContext } from 'react';
import bem from 'utils/bem';
import Logo from 'components/Logo';
import Text from 'components/Text';
import { IconButton } from 'components/Button';
import Model from '../../../../model';

import './index.sass';

const { block, el } = bem('front-top');

const Top = () => {

    const { modal } = Model;

    return (
        <div className={ block() }>
            <div className={ el('content') }>
                <div className={ el('top-part') }>
                    <div className={ el('logo') }>
                        <Logo/>
                    </div>
                    <div className={ el('slogan') }>
                        <Text uppercase>Команда лучших психологов всегда на вашей стороне</Text>
                    </div>
                </div>
                <div className={ el('bottom-part') }>
                    <div className={ el('button') }>
                        <IconButton name={ 'arrow-right' } mod={ 'transparent' } onClick={ modal.openOrderForm }>
                            <Text>Записаться на консультацию</Text>
                        </IconButton>
                    </div>
                    <div className={ el('description') }>
                        <Text>
                            В поисках собственных ответов мы встречаемся со множеством вопросов. Некоторые из них
                            непросто выдержать в одиночку. Поэтому мы объединили лучших психотерапевтов, работающих по
                            всему миру, чтобы они стали вашей поддержкой на пути к гармоничной и счастливой жизни.
                        </Text>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default memo(Top);
